import { c7Api } from './c7Api';

export interface IEvento {
    EventoID: string;
    Nombre: string;
    Fecha: string;
    Imagen: string;
}

class Eventos {
    
    private static eventosInstance: Eventos;
    private baseUrl:string = "api/eventos"
  
    private constructor() { }

    public static GetInstance(): Eventos {
        if(!Eventos.eventosInstance){
            Eventos.eventosInstance = new Eventos();
        }
        return Eventos.eventosInstance;
    }

    public async GetAllEvents():Promise<IEvento []> {
        return await c7Api.get(this.baseUrl);
    }

    public async DeleteEvent(id: number): Promise<IEvento> {
        return await c7Api.delete(`${this.baseUrl}/${id}`);
      }

    public async GetEvents():Promise<IEvento []> {
        try {
            // Hacemos la solicitud GET
            const eventos = await this.GetAllEvents();
            
            // Filtramos los eventos con imagen no nula y cuya fecha aún no ha pasado
            const filteredEventos = eventos.filter((evento: IEvento) => {
              const currentDate = new Date();
              const eventDate = new Date(evento.Fecha);
              
              // Comprobamos si la imagen no es nula y la fecha es futura
              return evento.Imagen && eventDate >= currentDate;
            });
        
            return filteredEventos; // Retornamos los eventos filtrados
          } catch (error) {
            console.error("Error al obtener los eventos:", error);
            throw error;
          }
    }

    public async UploadEvent(formData:FormData): Promise<any> {
        return await c7Api.postFormData(this.baseUrl, formData);
    }

   
}

  export const eventosLogic = Eventos.GetInstance();